import type { Template } from "@/types";

export const LA_07_H2_V5: Template[] = [
    {
        id: "la-07-h2v5-01",
        name: "LA 01 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 99, y: 99, width: 232, height: 165, rotation: 0, imageRotation: 0 },
            { id: "2", x: 99, y: 272, width: 232, height: 164, rotation: 0, imageRotation: 0 },
            { id: "3", x: 339, y: 99, width: 239, height: 337, rotation: 0, imageRotation: 0 },
            { id: "4", x: 845, y: 45, width: 166, height: 218, rotation: 0, imageRotation: 0 },
            { id: "5", x: 845, y: 271, width: 166, height: 217, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1019, y: 45, width: 165, height: 218, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1019, y: 271, width: 165, height: 217, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-02",
        name: "LA 02 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 62, y: 63, width: 289, height: 198, rotation: 0, imageRotation: 0 },
            { id: "2", x: 62, y: 269, width: 289, height: 198, rotation: 0, imageRotation: 0 },
            { id: "3", x: 358, y: 63, width: 256, height: 404, rotation: 0, imageRotation: 0 },
            { id: "4", x: 821, y: 64, width: 280, height: 404, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1109, y: 64, width: 94, height: 130, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1109, y: 201, width: 94, height: 130, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1109, y: 339, width: 94, height: 130, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-03",
        name: "LA 03 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 133, y: 49, width: 310, height: 213, rotation: 0, imageRotation: 0 },
            { id: "2", x: 133, y: 270, width: 310, height: 213, rotation: 0, imageRotation: 0 },
            { id: "3", x: 451, y: 49, width: 94, height: 140, rotation: 0, imageRotation: 0 },
            { id: "4", x: 451, y: 197, width: 94, height: 139, rotation: 0, imageRotation: 0 },
            { id: "5", x: 451, y: 345, width: 94, height: 139, rotation: 0, imageRotation: 0 },
            { id: "6", x: 800, y: 101, width: 212, height: 330, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1020, y: 101, width: 211, height: 330, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-04",
        name: "LA 04 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 133, y: 49, width: 94, height: 139, rotation: 0, imageRotation: 0 },
            { id: "2", x: 133, y: 196, width: 94, height: 139, rotation: 0, imageRotation: 0 },
            { id: "3", x: 133, y: 344, width: 94, height: 138, rotation: 0, imageRotation: 0 },
            { id: "4", x: 235, y: 49, width: 310, height: 213, rotation: 0, imageRotation: 0 },
            { id: "5", x: 235, y: 270, width: 310, height: 213, rotation: 0, imageRotation: 0 },
            { id: "6", x: 769, y: 77, width: 242, height: 377, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1019, y: 77, width: 241, height: 377, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-05",
        name: "LA 05 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 47, y: 163, width: 284, height: 207, rotation: 0, imageRotation: 0 },
            { id: "2", x: 338, y: 163, width: 284, height: 207, rotation: 0, imageRotation: 0 },
            { id: "3", x: 630, y: 163, width: 129, height: 207, rotation: 0, imageRotation: 0 },
            { id: "4", x: 767, y: 163, width: 129, height: 207, rotation: 0, imageRotation: 0 },
            { id: "5", x: 904, y: 163, width: 128, height: 207, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1040, y: 163, width: 128, height: 207, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1176, y: 163, width: 128, height: 207, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-06",
        name: "LA 06 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 389, height: 531, rotation: 0, imageRotation: 0 },
            { id: "2", x: 746, y: 84, width: 265, height: 174, rotation: 0, imageRotation: 0 },
            { id: "3", x: 746, y: 266, width: 129, height: 181, rotation: 0, imageRotation: 0 },
            { id: "4", x: 883, y: 266, width: 128, height: 181, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1019, y: 84, width: 264, height: 174, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1019, y: 266, width: 128, height: 181, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1155, y: 266, width: 128, height: 181, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-07",
        name: "LA 07 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 676, height: 531, rotation: 0, imageRotation: 0 },
            { id: "2", x: 783, y: 39, width: 462, height: 309, rotation: 0, imageRotation: 0 },
            { id: "3", x: 783, y: 356, width: 86, height: 134, rotation: 0, imageRotation: 0 },
            { id: "4", x: 877, y: 356, width: 86, height: 134, rotation: 0, imageRotation: 0 },
            { id: "5", x: 971, y: 356, width: 86, height: 134, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1065, y: 356, width: 86, height: 134, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1159, y: 356, width: 86, height: 134, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-08",
        name: "LA 08 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 234, y: 58, width: 132, height: 204, rotation: 0, imageRotation: 0 },
            { id: "2", x: 234, y: 270, width: 132, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 374, y: 58, width: 131, height: 204, rotation: 0, imageRotation: 0 },
            { id: "4", x: 374, y: 270, width: 131, height: 203, rotation: 0, imageRotation: 0 },
            { id: "5", x: 513, y: 58, width: 306, height: 204, rotation: 0, imageRotation: 0 },
            { id: "6", x: 513, y: 270, width: 306, height: 203, rotation: 0, imageRotation: 0 },
            { id: "7", x: 827, y: 58, width: 291, height: 415, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-09",
        name: "LA 09 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 95, width: 210, height: 339, rotation: 0, imageRotation: 0 },
            { id: "2", x: 218, y: 95, width: 210, height: 339, rotation: 0, imageRotation: 0 },
            { id: "3", x: 436, y: 95, width: 476, height: 339, rotation: 0, imageRotation: 0 },
            { id: "4", x: 919, y: 95, width: 210, height: 339, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1137, y: 95, width: 217, height: 156, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1137, y: 259, width: 104, height: 175, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1248, y: 259, width: 104, height: 175, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-10",
        name: "LA 10 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 95, width: 476, height: 339, rotation: 0, imageRotation: 0 },
            { id: "2", x: 484, y: 95, width: 210, height: 339, rotation: 0, imageRotation: 0 },
            { id: "3", x: 701, y: 95, width: 210, height: 339, rotation: 0, imageRotation: 0 },
            { id: "4", x: 919, y: 95, width: 210, height: 339, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1137, y: 95, width: 217, height: 156, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1137, y: 259, width: 104, height: 175, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1248, y: 259, width: 104, height: 175, rotation: 0, imageRotation: 0 }
        ],
    }
];